// ★ 2026-08-14 (Fase 54) — Config centralizzata Senior/Calendly per paese.
//
// Riorganizzazione team HCF Property (post CONSOB compliance):
//   • Albania (Real Estate): Mattia, Morosini
//   • Indonesia / Thailandia (Real Estate): Morosini
//   • Equity generale: Vincenzo, Alessandro (backoffice — NON in prima linea)
//
// Tutti gli agenti listati qui sono sia Associate che Senior.
// Il CEO (Richard) rimane sempre disponibile come opzione universale.
//
// Usato da: BookSeniorModal, ProjectDocuments, LombokUnitsTable,
// PropertyUnitsTable, ResortDetailPage e ovunque serva contatto lead.

// ── Senior public-facing per paese ─────────────────────────────────────
export const COUNTRY_SENIORS = {
  albania: {
    country: 'Albania',
    flag: '🇦🇱',
    seniors: [
      {
        id: 'mattia',
        name: 'Mattia Demichele',
        title: 'Co-CEO & Senior Associate — Albania',
        role: 'senior',
        calendly: 'https://calendly.com/mattia-demichele/co-ceo-hcf-property-shpk',
        avatar: 'MD',
      },
      {
        id: 'morosini',
        name: 'Francesco Morosini',
        title: 'Senior Associate — Albania',
        role: 'senior',
        calendly: 'https://calendly.com/fmorosini4/scopri-hcf-property-1-greenparadise?month=2026-05',
        avatar: 'FM',
      },
    ],
  },
  indonesia: {
    country: 'Indonesia',
    flag: '🇮🇩',
    seniors: [
      {
        id: 'morosini',
        name: 'Francesco Morosini',
        title: 'Senior Associate — Indonesia',
        role: 'senior',
        calendly: 'https://calendly.com/fmorosini4/scopri-hcf-property-1-greenparadise?month=2026-05',
        avatar: 'FM',
      },
    ],
  },
  // Thailandia (Chumphon) e Norvegia (Spille) — mostrano gli stessi senior
  // del rispettivo continente (asia/europa). Fallback team Indonesia per Asia.
  thailandia: {
    country: 'Thailandia',
    flag: '🇹🇭',
    seniors: [
      {
        id: 'morosini',
        name: 'Francesco Morosini',
        title: 'Senior Associate — Asia (Indonesia, Thailandia)',
        role: 'senior',
        calendly: 'https://calendly.com/fmorosini4/scopri-hcf-property-1-greenparadise?month=2026-05',
        avatar: 'FM',
      },
    ],
  },
  norvegia: {
    country: 'Norvegia',
    flag: '🇳🇴',
    seniors: [
      // Nessun senior dedicato per la Norvegia (progetto Spille sold-out).
      // Solo il CEO come opzione universale.
    ],
  },
};

// CEO — sempre disponibile per QUALSIASI paese
export const CEO_OPTION = {
  id: 'ceo',
  name: 'Richard Demichele',
  title: 'CEO HCF Group',
  role: 'ceo',
  calendly: 'https://calendly.com/legal-housecashflows/colloquio-strategico-con-il-ceo-di-hcf-group',
  avatar: 'RD',
  scope: 'Disponibile per tutti i paesi',
};

// ★ Backoffice Equity (Vincenzo, Alessandro) — NON esposto pubblicamente.
// Referenziato solo in dashboard interne / assignazioni CRM.
export const BACKOFFICE_EQUITY = [
  {
    id: 'vincenzo',
    name: 'Vincenzo Stasi',
    email: 'vincenzo@housecashflows.com',
    title: 'Senior Associate — Equity (Backoffice)',
    role: 'senior_backoffice',
    country_focus: 'EQUITY',
    public_facing: false,
  },
  {
    id: 'alessandro',
    name: 'Alessandro Padoan',
    email: 'alessandro.padoan@housecashflows.com',
    title: 'Senior Associate — Equity (Backoffice)',
    role: 'senior_backoffice',
    country_focus: 'EQUITY',
    public_facing: false,
  },
];

// Mappa slug → paese (usato per instradare le CTA dei resort)
export const SLUG_COUNTRY = {
  'narea':            'albania',
  'la-mar-residence': 'albania',
  'palm-paradise':    'albania',
  'vista-mare':       'albania',
  'green-paradise-lombok': 'indonesia',
  'spille':           'norvegia',
  'lombok':           'indonesia',
  'chumphon':         'thailandia',
};

/**
 * Restituisce l'elenco degli agenti PUBLIC-FACING selezionabili per un dato
 * project slug. Include SEMPRE il CEO come opzione universale in coda.
 * Vincenzo e Alessandro (equity backoffice) sono ESCLUSI da questa lista.
 *
 * @param {string} slug  project slug (es. 'lombok', 'narea')
 * @returns {{country, flag, seniors: Array}}
 */
export function getSeniorsForSlug(slug) {
  const country = SLUG_COUNTRY[slug];
  const regional = country ? COUNTRY_SENIORS[country] : null;
  return {
    country: regional?.country || 'Multi-paese',
    flag:    regional?.flag    || '🌐',
    seniors: [
      ...(regional?.seniors || []),
      CEO_OPTION,
    ],
  };
}

export default {
  COUNTRY_SENIORS,
  CEO_OPTION,
  BACKOFFICE_EQUITY,
  SLUG_COUNTRY,
  getSeniorsForSlug,
};
